const compareVr = (v1:string, v2:string) => {
  const v1arr = v1.split('.')
  const v2arr = v2.split('.')
  // if(v1arr.length != v2arr.length) {
  //     plus.nativeUI.alert(`更新包版本错误`, () => {
  //         force && plus.runtime.quit()
  //     }, "", "确认")
  //     throw new Error("更新包版本错误")
  // }
  const len = v1arr.length > v2arr.length ? v1arr.length : v2arr.length;
  for (let index = 0; index < len; index++) {
    const v1pos = v1arr[index] || 0;
    const v2pos = v2arr[index] || 0;
    if (Number(v1pos) > Number(v2pos)) {
      return 'big'
    }
    if (Number(Number(v1pos) < Number(v2pos))) {
      return 'small'
    }
  }

  return 'same'
}

// @ts-ignore
window.compareVr = compareVr

// 定义更新检查函数
export const checkUpdate = (appVersion: string, {
  currentVersion,
  minVersion,
  packageAddress,
  updatePackageAddress
}: {
  currentVersion: string;
  minVersion: string;
  packageAddress: string;
  updatePackageAddress: string;
}): boolean | void => {
  try {
      const plus = window.plus as any;
      if (window.plus) {
          const mv: string = minVersion;
          const apv: string = appVersion;
          // 定义安装处理函数
          const installHandle = (isUpdated: boolean): void => {
              if (isUpdated) {
                  plus.runtime.restart();
              } else {
                  plus.nativeUI.alert('更新包安装失败！', () => {
                      plus.runtime.quit();
                  }, '', '确认');
              }
          };

          // 定义更新函数
          const update = (): void => {
              plus.nativeUI.showWaiting('下载安装中...');
              const slice: string[] = updatePackageAddress.split('/');
              slice.pop();
              slice.push(`${plus.runtime.appid}.wgt`);
              // 假设h5p.downWgt是一个已定义的函数，这里进行类型断言
              // @ts-ignore
              (window.h5p as { downWgt: (url: string, callback: (isDownloaded: boolean, next: (isUpdated: boolean) => void) => void) => void }).downWgt(slice.join('/'), (isDownloaded: boolean, next: (isUpdated: boolean) => void): void => {
                  if (isDownloaded) {
                      // 强制更新逻辑
                      // @ts-ignore
                      next((isUpdated) =>{ installHandle(isUpdated); });
                  } else {
                      plus.nativeUI.alert('更新包下载失败！', () => {
                          plus.runtime.quit();
                      }, '', '确认');
                  }
              });
          };

          // 比较版本号，如果appVersion小于minVersion，则执行更新
          if (compareVr(apv, mv) ==='small') {
              update();
              return true;
          }
          return false;
      }
  } catch (error) {
      if (error instanceof Error) {
          console.error('检测更新失败', error.message);
      } else {
          console.error('检测更新失败', error);
      }
  }
};